<template>
  <nav>
    <ProjectsMenu />
    <ul class="menu">
      <router-link tag="li" :to="{ name: 'events' }" class="menu__item" active-class="btn--active">
        <b-button class="btn--menu text-uppercase" variant="link">
          <Icon name="event" />
          Events (last 7 days)
        </b-button>
      </router-link>
      <router-link
        v-if="isAdmin"
        tag="li"
        :to="{ name: 'admin' }"
        class="menu__item menu__item--no-decor"
        active-class="btn--active"
      >
        <b-button class="btn--menu text-uppercase" variant="link">
          <Icon name="admin" />
          Admin panel
        </b-button>
      </router-link>
      <li class="menu__switch-theme menu__item--no-decor">
        Night mode {{ darkMode ? 'on' : 'off' }}
        <Switches
          :value="darkMode"
          theme="custom"
          color="custom"
          @input="v => changeTheme(v, darkMode)"
        />
      </li>
      <router-link
        tag="li"
        :to="{ name: 'sign-out' }"
        class="menu__item menu__item--no-decor"
        active-class="menu__item--active"
      >
        <b-button class="btn--menu text-uppercase" variant="link">
          <Icon name="logout" />
          Log out
        </b-button>
      </router-link>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectsMenu from '@/components/projects/projects-menu';

export default {
  name: 'MainMenu',
  components: { ProjectsMenu },
  data() {
    return {
      darkTheme: this.darkMode
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: 'auth/isAdminOrSuperadmin',
      darkMode: 'darkMode'
    })
  },
  methods: {
    changeTheme(val, darkMode) {
      if (typeof darkMode !== 'undefined') {
        this.$store.commit('toggleDarkMode', val);
        this.$nextTick();
      }
    }
  }
};
</script>
